/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Shop_Tier_Name_InvalidInputs */

const vi_error_shop_tier_name_invalid = /** @type {(inputs: Error_Shop_Tier_Name_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tên hạng phải có 1 đến ${i?.max} ký tự.`)
};

/**

* @param {Error_Shop_Tier_Name_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_tier_name_invalid = /** @type {((inputs: Error_Shop_Tier_Name_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Tier_Name_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_tier_name_invalid(inputs)
});